<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="filterOptions.roles"
            :disabled="filters.accountingFirmUser === 0"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        >
            <template #first>
                <b-form-select-option :value="0"
                    >Tous les rôles</b-form-select-option
                >
            </template>
        </b-form-select>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'SelectRole',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
        }),

        selectClass() {
            return this.option === 0 ? 'bg-white' : 'selected-filter'
        },
    },

    async created() {
        this.option = this.filters.role
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch('reportingVM/setRoleFilter', this.option)
            this.$emit('role-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>

<style scoped></style>
